import TermsAndConditionsComponent from './TermsAndConditionsContainer';

export default TermsAndConditionsComponent;
